import { fetchData } from 'utils';

export type ClientPhoneData = {
  mobilePhone: string;
  status: string;
};

export default async function getClientPhone(): Promise<ClientPhoneData> {
  return await fetchData('/client/phone');
}
